import { z } from "zod";


export const ContaReceberParcialSchema = z.object({

    idBancoPagamento: z.number().optional().nullable(),
    idContasReceber: z.number({
        required_error: "Selecione uma conta a receber",
        invalid_type_error: "ID da conta inválido"
    }).nullable().default(null),
    dataBaixa: z.coerce.date({ invalid_type_error: "Data recebida inválida." })
        .default(new Date()),
    valorBaixa: z.coerce.number({
        required_error: "Informe o valor do recebimento",
        invalid_type_error: "Valor inválido"
    }).nonnegative("O valor não pode ser negativo"),
    formaPagamento: z.string().optional().nullable(),

});

export type ContaReceberParcialForm = z.infer<typeof ContaReceberParcialSchema>;

export const defaultContaReceberParcialForm: Partial<ContaReceberParcialForm> = {
    dataBaixa: new Date(),
    idContasReceber: null,

}